module.exports = "/Public/build/ce16c801ec3b27a0fb27d8004dca846a.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/hamburger.svg
// module id = 835
// module chunks = 0